// import React, { useState } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   Tabs,
//   Tab,
//   Box,
//   Paper,
//   Typography,
//   Divider,
// } from "@mui/material";

// const UserManualPopup = ({ open, onClose }) => {
//   const [activeTab, setActiveTab] = useState(0);

//   // All tab labels
//   const tabLabels = [
//     "User Manual",
//     "Video Tutorial",
//     "FAQ",
//     "SOP",
//     "Sample Drawing",
//     "Building Byelaws & GO",
//   ];

//   // Handle tab change
//   const handleTabChange = (event, newValue) => {
//     setActiveTab(newValue);
//   };

//   // Tab Panel Component
//   const TabPanel = ({ children, value, index }) => {
//     return (
//       <Box
//         role="tabpanel"
//         hidden={value !== index}
//         id={`tabpanel-${index}`}
//         aria-labelledby={`tab-${index}`}
//         sx={{
//           p: 3,
//           backgroundColor: "#fff",
//           minHeight: 220,
//           borderRadius: 1,
//           boxShadow: 1,
//         }}
//       >
//         {value === index && children}
//       </Box>
//     );
//   };

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       fullWidth
//       maxWidth="md"
//       sx={{
//         "& .MuiDialog-paper": {
//           borderRadius: 2,
//           backgroundColor: "#f5f5f5",
//         },
//       }}
//     >
//       <DialogTitle
//         sx={{
//           textAlign: "center",
//           fontWeight: 600,
//           fontSize: "1.2rem",
//           pb: 1,
//         }}
//       >
//         Manual & Documents
//       </DialogTitle>
//       <Divider />

//       <DialogContent sx={{ pt: 2, backgroundColor: "#e0e0e0" }}>
//         {/* Tabs Section */}
//         <Paper
//           elevation={0}
//           sx={{
//             display: "flex",
//             justifyContent: "center",
//             backgroundColor: "transparent",
//             mb: 2,
//           }}
//         >
//           <Tabs
//             value={activeTab}
//             onChange={handleTabChange}
//             variant="scrollable"
//             scrollButtons="auto"
//             TabIndicatorProps={{ style: { backgroundColor: "#009688" } }}
//             textColor="inherit"
//             sx={{
//               "& .MuiTab-root": {
//                 textTransform: "none",
//                 fontWeight: 600,
//                 borderRadius: 1,
//                 mx: 0.5,
//                 backgroundColor: "#b2dfdb",
//                 color: "#000",
//                 minWidth: 120,
//                 "&.Mui-selected": {
//                   backgroundColor: "#7cd0ca",
//                   color: "#000",
//                 },
//               },
//             }}
//           >
//             {tabLabels.map((label, index) => (
//               <Tab key={index} label={label} id={`tab-${index}`} />
//             ))}
//           </Tabs>
//         </Paper>

//         {/* Tab Content Section */}
//         <Box>
//           <TabPanel value={activeTab} index={0}>
//             <Typography>User Manual Component</Typography>
//           </TabPanel>
//           <TabPanel value={activeTab} index={1}>
//             <Typography>Video Tutorial Component</Typography>
//           </TabPanel>
//           <TabPanel value={activeTab} index={2}>
//             <Typography>FAQ Component</Typography>
//           </TabPanel>
//           <TabPanel value={activeTab} index={3}>
//             <Typography>SOP Component</Typography>
//           </TabPanel>
//           <TabPanel value={activeTab} index={4}>
//             <Typography>Sample Drawing Component</Typography>
//           </TabPanel>
//           <TabPanel value={activeTab} index={5}>
//             <Typography>Building Byelaws & GO Component</Typography>
//           </TabPanel>
//         </Box>
//       </DialogContent>
//     </Dialog>
//   );
// };

// export default UserManualPopup;

// import React, { useState } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   Tabs,
//   Tab,
//   Box,
//   Paper,
//   Typography,
//   Divider,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   TableContainer,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
// } from "@mui/material";

// const UserManualPopup = ({ open, onClose }) => {
//   const [activeTab, setActiveTab] = useState(0);
//   const [office, setOffice] = useState("");

//   const tabLabels = [
//     "User Manual",
//     "Video Tutorial",
//     "FAQ",
//     "SOP",
//     "Sample Drawing",
//     "Building Byelaws & GO",
//   ];
//   // Example static data (you can replace this with API data)
//   const tableData = [
//     {
//       id: 1,
//       category: "Citizen Portal",
//       description: "User manual for citizen portal usage",
//       updatedOn: "2025-10-05",
//       link: "#",
//       isApproval: true,
//     },
//     {
//       id: 2,
//       category: "Officer Portal",
//       description: "Workflow and role-based guide for officials",
//       updatedOn: "2025-09-22",
//       link: "#",
//       isApproval: false,
//     },
//   ];

//   const handleTabChange = (event, newValue) => setActiveTab(newValue);

//   const TabPanel = ({ children, value, index }) => (
//     <Box
//       role="tabpanel"
//       hidden={value !== index}
//       sx={{
//         p: 3,
//         backgroundColor: "#fff",
//         borderRadius: 1,
//         boxShadow: 1,
//         minHeight: 240,
//       }}
//     >
//       {value === index && children}
//     </Box>
//   );

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       fullWidth
//       maxWidth="md"
//       sx={{
//         "& .MuiDialog-paper": {
//           borderRadius: 2,
//           backgroundColor: "#ebf3fa",
//         },
//       }}
//     >
//       <DialogTitle
//         sx={{
//           textAlign: "center",
//           fontWeight: 600,
//           fontSize: "1.3rem",
//           background: "linear-gradient(to right, #0c5a88, #1976d2)",
//           color: "#fff",
//           padding: "8px 20px",
//           lineHeight: 1.0,
//         }}
//       >
//         Manual & Documents
//       </DialogTitle>

//       <DialogContent sx={{ p: 3 }}>
//         {/* Top Tabs */}
//         <Paper
//           elevation={0}
//           sx={{
//             display: "flex",
//             justifyContent: "center",
//             backgroundColor: "transparent",
//             mb: 2,
//             mt: 2,
//           }}
//         >
//           <Tabs
//             value={activeTab}
//             onChange={handleTabChange}
//             variant="scrollable"
//             scrollButtons="auto"
//             TabIndicatorProps={{ style: { backgroundColor: "#0c5a88" } }}
//             sx={{
//               "& .MuiTab-root": {
//                 textTransform: "none",
//                 fontWeight: 600,
//                 borderRadius: 1,
//                 mx: 0.5,
//                 backgroundColor: "#c5e3f6",
//                 color: "#0c3d64",
//                 minWidth: 140,
//                 "&.Mui-selected": {
//                   backgroundColor: "#0c5a88",
//                   color: "#fff",
//                 },
//               },
//             }}
//           >
//             {tabLabels.map((label, index) => (
//               <Tab key={index} label={label} />
//             ))}
//           </Tabs>
//         </Paper>

//         {/* Tab Panels */}
//         <TabPanel value={activeTab} index={0}>
//          <Typography>
//             {/* Tab Panels */}
//         {tabLabels.map((label, index) => (
//           <TabPanel key={index} value={activeTab} index={index}>
//             <TableContainer
//               component={Paper}
//               elevation={0}
//               sx={{
//                 border: "1px solid #d3e3f0",
//                 borderRadius: 1,
//                 maxHeight: 350,
//                 overflow: "auto",
//               }}
//             >
//               <Table size="small">
//                 <TableHead>
//                   <TableRow sx={{ backgroundColor: "#e6f2fb" }}>
//                     <TableCell sx={{ fontWeight: 600 }}>S.No.</TableCell>
//                     <TableCell sx={{ fontWeight: 600 }}>Category</TableCell>
//                     <TableCell sx={{ fontWeight: 600 }}>Description</TableCell>
//                     <TableCell sx={{ fontWeight: 600 }}>Updated On</TableCell>
//                     <TableCell sx={{ fontWeight: 600 }}>Download Link</TableCell>
//                     <TableCell sx={{ fontWeight: 600 }}>isApproval</TableCell>
//                   </TableRow>
//                 </TableHead>

//                 <TableBody>
//                   {tableData.map((row, i) => (
//                     <TableRow
//                       key={row.id}
//                       sx={{
//                         "&:nth-of-type(even)": {
//                           backgroundColor: "#f9fcff",
//                         },
//                       }}
//                     >
//                       <TableCell>{i + 1}</TableCell>
//                       <TableCell>{row.category}</TableCell>
//                       <TableCell>{row.description}</TableCell>
//                       <TableCell>{row.updatedOn}</TableCell>
//                       <TableCell>
//                         <Link href={row.link} underline="hover" color="#1976d2">
//                           Download
//                         </Link>
//                       </TableCell>
//                       <TableCell>
//                         <Checkbox checked={row.isApproval} disabled />
//                       </TableCell>
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//               </TableContainer>
//               </TabPanel>
//               ))}
//          </Typography>
// </TabPanel>

//         <TabPanel value={activeTab} index={1}>
//           <Typography>🎥 Video Tutorial Content</Typography>
//         </TabPanel>

//         <TabPanel value={activeTab} index={2}>
//           <Typography>❓ FAQ Section</Typography>
//         </TabPanel>

//         <TabPanel value={activeTab} index={3}>
//           <Typography>📘 SOP Content</Typography>
//         </TabPanel>

//         <TabPanel value={activeTab} index={4}>
//           <Typography>📄 Sample Drawing Section</Typography>
//         </TabPanel>

//         <TabPanel value={activeTab} index={5}>
//           <Typography>🏗️ Building Byelaws & GO Content</Typography>
//         </TabPanel>
//       </DialogContent>
//     </Dialog>
//   );
// };

// export default UserManualPopup;

import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Tabs,
  Tab,
  Box,
  Paper,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Link,
  Checkbox,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import UserManualTable from "./UserManualTable";
import VideoTutorial from "./VideoTutorial";
import FAQTable from "./FAQ";
import SOPTable from "./SOP";
import SampleDrawing from "./SampleDrawing";
import BuildingShow from "./BuildingByelaws";
import VideoTraining from "./VideoTraining";

const UserManualPopup = ({ open, onClose }) => {
  const [activeTab, setActiveTab] = useState(0);

  const userInfo = Digit.UserService.getUser()?.info || {};
  const isEmployee = userInfo?.type === "EMPLOYEE";

  const tabs = [
    {
      label: "User Manual",
      content: <UserManualTable tenantId="hp" formType="manual" />,
    },
    {
      label: "Video Tutorial",
      content: <VideoTutorial tenantId="hp" formType="manual" />,
    },
    {
      label: "FAQ",
      content: <FAQTable tenantId="hp" formType="manual" />,
    },
    {
      label: "SOP",
      content: <SOPTable tenantId="hp" formType="manual" />,
    },
    {
      label: "Building Byelaws and GO",
      content: <BuildingShow tenantId="hp" formType="manual" />,
    },
    ...(!isEmployee
      ? [
          {
            label: "Training Video",
            content: <VideoTraining tenantId="hp" formType="manual" />,
          },

          {
            label: "Sample Drawing",
            content: <SampleDrawing tenantId="hp" formType="manual" />,
          },
        ]
      : []),
  ];

  const handleTabChange = (event, newValue) => setActiveTab(newValue);

  useEffect(() => {
    if (activeTab >= tabs.length) {
      setActiveTab(0);
    }
  }, [activeTab, tabs.length]);

  const TabPanel = ({ children, value, index }) => (
    <Box
      role="tabpanel"
      hidden={value !== index}
      sx={{
        p: 3,
        backgroundColor: "#fff",
        borderRadius: 1,
        boxShadow: 1,
        minHeight: 240,
      }}
    >
      {value === index && children}
    </Box>
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: 2,
          backgroundColor: "#ebf3fa",
          width: "90%",
          maxWidth: "1200px",
          position: "relative",
        },
      }}
    >
      {/* Smaller Close Button */}
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          top: 4,
          right: 4,
          zIndex: 9999,
          color: "#fff",
          backgroundColor: "rgba(255,255,255,0.2)",
          width: 28, // Smaller width
          height: 28, // Smaller height
          "&:hover": {
            backgroundColor: "rgba(255,255,255,0.3)",
          },
          "& .MuiSvgIcon-root": {
            fontSize: "18px", // Smaller icon size
          },
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogTitle
        sx={{
          textAlign: "center",
          fontWeight: 600,
          fontSize: "1.3rem",
          background: "linear-gradient(to right, #0c5a88, #1976d2)",
          color: "#fff",
          padding: "12px 20px", // Adjusted padding
          lineHeight: 1.0,
          position: "relative",
          minHeight: "60px", // Ensure consistent header height
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            left: 20,
            top: 0,
            bottom: 0,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            textAlign: "left",
            "& span": {
              fontSize: "0.85rem",
              lineHeight: 1.2,
            },
            "& a": {
              cursor: "pointer",
            },
          }}
          className="manual-documents-title"
        >
          {isEmployee && (
            <React.Fragment>
              <span>Contact: 08064522140</span>
              <span>
                Helpdesk: <a onClick={() => window.open("https://mainet.abmindia.com/training/", "_blank")}>Click Here</a>
              </span>
            </React.Fragment>
          )}
        </Box>
        <div>Manual & Documents</div>
      </DialogTitle>

      <DialogContent sx={{ p: 3 }}>
        {/* Tabs Header */}
        <Paper
          elevation={0}
          sx={{
            display: "flex",
            justifyContent: "center",
            backgroundColor: "transparent",
            mb: 2,
            mt: 2,
          }}
        >
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            TabIndicatorProps={{ style: { backgroundColor: "#0c5a88" } }}
            sx={{
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: 600,
                borderRadius: 1,
                mx: 0.5,
                backgroundColor: "#c5e3f6",
                color: "#0c3d64",
                minWidth: 140,
                "&.Mui-selected": {
                  backgroundColor: "#0c5a88",
                  color: "#fff",
                },
              },
            }}
          >
            {tabs.map((tab, index) => (
              <Tab key={index} label={tab.label} />
            ))}
          </Tabs>
        </Paper>

        {tabs.map((tab, index) => (
          <TabPanel key={index} value={activeTab} index={index}>
            {tab.content}
          </TabPanel>
        ))}
      </DialogContent>
    </Dialog>
  );
};

export default UserManualPopup;
